const BorderCustoms = () => {
  return (
    <div>
    
    <div className="flex flex-col justify-center  gap-1 max-w-[50rem] mx-auto pl-[2rem] pt-[1rem] pr-[2rem]">
      <h1 className="text-[20px] font-bold">Cross-border Customs</h1>
      <p>
        The process of going through cross-border protections and customs can be a real hassle. 
        The procedures require a coordinated facilitation of customs clearance while complying with 
        the security procedures dictated by the border agencies of two or more countries. TCS customs 
        house clearance services can help you avoid the negative impact on your organisation’s economic 
        developments, by making sure that your goods get cleared with ease. 
      </p>

     
    </div>
  </div>
  );
};
  
export default BorderCustoms;
  